import './index.css'
import cn from 'clsx'

import React, { Component } from 'react'
import { getOptimizedFormat, getOriginalFormat } from '@disco/utils/tracks'
import SelectableTrackFormats from 'components/common/selectable-track-formats'
import TrackInfo from 'components/common/track-info'
import { HoverProvider } from 'components/ui/hover-provider'
import Icon from 'components/ui/icon'
import type { Track } from 'types/track'

type Props = {
  track: Track
  index: number
  selected?: boolean
  originalFormatSelected?: boolean
  onSelect: (...args: Array<any>) => any
  onOriginalFormatSelect: (...args: Array<any>) => any
  playlistId?: number
  displayFormatCheckboxes?: boolean
}

class SelectableTrack extends Component<Props> {
  _onClick: () => any = () =>
    this.props.onSelect(this.props.track, this.props.index)
  _onFormatClick: (format: string) => void = (format: string) => {
    const optFormat = getOptimizedFormat(this.props.track)
    const originalFormat = getOriginalFormat(this.props.track)
    if (format === optFormat)
      this.props.onSelect(this.props.track, this.props.index)
    if (format === originalFormat)
      this.props.onOriginalFormatSelect(this.props.track, this.props.index)
  }

  render(): React.ReactNode {
    const {
      track,
      selected,
      playlistId,
      displayFormatCheckboxes,
      originalFormatSelected,
    } = this.props
    const className = cn('BulkEditor_Item', {
      'is-selected': selected,
    })
    const optFormat = getOptimizedFormat(track)
    const originalFormat = getOriginalFormat(track)
    let selectedFormats: (string | null | undefined)[] = []
    if (!!originalFormatSelected) selectedFormats.push(originalFormat)
    if (!!selected) selectedFormats.push(optFormat)
    return (
      <HoverProvider>
        <div className={className}>
          <div className="BulkEditor_Check no-outline" onClick={this._onClick}>
            {selected && <Icon type="check" />}
          </div>
          <div className="BulkEditor_Track">
            <TrackInfo track={track} location="edit-metadata" />
          </div>
          {displayFormatCheckboxes && (
            <SelectableTrackFormats
              className="BulkEditor_TrackFormat"
              formats={Object.keys(track.all_files ?? {})}
              selectedFormats={selectedFormats}
              onFormatClick={this._onFormatClick}
            />
          )}
        </div>
      </HoverProvider>
    )
  }
}

export default SelectableTrack
